import styled from "styled-components"

const About = styled.div`
& > * {
    margin-bottom: 48px;
    margin-right: 96px;
  }

`

export default About